import { FilterDropdownType, FilterOption } from 'components/more-filters/MoreFilters';
import { getCustomerDateDefaultRange } from './Utils';

export enum ADDRESS_TYPE {
  SERVICE = 'SERVICE',
  BILLING = 'BILLING'
}

export const initialAddressState = {
  id: 0,
  street: '',
  addressName: '',
  addressNote: '',
  apartment: '',
  city: '',
  country: '',
  zipCode: '',
  state: '',
  latitude: 0,
  longitude: 0
};

export enum CustomerFilterIds {
  TOTAL_INVOICED = 'TOTAL_INVOICED',
  OUTSTANDING_BALANCE = 'OUTSTANDING_BALANCE',
  CARD_ON_FILE = 'CARD_ON_FILE',
  LAST_ACTIVITY = 'LAST_ACTIVITY',
  CREATED_DATE = 'CREATED_DATE',
  NUMBER_OF_JOBS = 'NUMBER_OF_JOBS',
  TOTAL_PAID = 'TOTAL_PAID',
  CREATED_BY = 'CREATED_BY',
  DISPUTE_LOSSES = 'DISPUTE_LOSSES',
  REFUNDS = 'REFUNDS'
}

export const CUSTOMER_MORE_FILTER_OPTIONS: FilterOption[] = [
  {
    id: CustomerFilterIds.CREATED_DATE,
    label: 'Created date',
    type: FilterDropdownType.DATE,
    dateFilterProps: {
      customRanges: getCustomerDateDefaultRange(),
      hasDefaultRanges: false
    }
  },
  {
    id: CustomerFilterIds.NUMBER_OF_JOBS,
    label: 'Number of jobs',
    type: FilterDropdownType.AMOUNT,
    isAmountFilter: false
  },
  { id: CustomerFilterIds.TOTAL_PAID, label: 'Total paid', type: FilterDropdownType.AMOUNT, isAmountFilter: true },
  {
    id: CustomerFilterIds.CREATED_BY,
    label: 'Created by',
    type: FilterDropdownType.DROPDOWN,
    idKey: 'merchantId',
    nameKey: 'firstName',
    secondaryDataKey: 'lastName'
  },
  {
    id: CustomerFilterIds.DISPUTE_LOSSES,
    label: 'Dispute losses',
    type: FilterDropdownType.AMOUNT,
    isAmountFilter: true
  },
  { id: CustomerFilterIds.REFUNDS, label: 'Refunds', type: FilterDropdownType.AMOUNT, isAmountFilter: false }
];

export const CARD_ON_FILE_OPTIONS = [
  { label: 'Has card on file', value: 'gt:0' },
  { label: 'No card on file', value: 'eq:0' }
];
